module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/peak-copy-dialog/peak-copy-dialog.component.scss
// module id = 1233
// module chunks = 0